var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProctoringIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.57,
    height: 51.57,
    viewBox: "0 0 51.57 51.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7661",
    "data-name": "Group 7661",
    transform: "translate(18971.5 -8432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7660",
    "data-name": "Group 7660",
    transform: "translate(-18971.5 8432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9859",
    "data-name": "Path 9859",
    d: "M13.932,56.25A1.433,1.433,0,0,0,12.5,57.682V70.574a7.181,7.181,0,0,0,7.163,7.163H33.988a1.433,1.433,0,0,0,0-2.866H19.663a4.256,4.256,0,0,1-4.3-4.3V57.681a1.435,1.435,0,0,0-1.434-1.432Z",
    transform: "translate(-12.5 -26.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9860",
    "data-name": "Path 9860",
    d: "M75.656,56.25a1.433,1.433,0,0,0-1.434,1.432V70.574a4.256,4.256,0,0,1-4.3,4.3H55.6a1.433,1.433,0,1,0,0,2.866H69.924a7.181,7.181,0,0,0,7.163-7.163V57.682a1.431,1.431,0,0,0-1.432-1.432Z",
    transform: "translate(-25.517 -26.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9861",
    "data-name": "Path 9861",
    d: "M19.663,12.5A7.181,7.181,0,0,0,12.5,19.663V32.556a1.433,1.433,0,0,0,2.866,0V19.663a4.256,4.256,0,0,1,4.3-4.3H32.556a1.433,1.433,0,1,0,0-2.866Z",
    transform: "translate(-12.5 -12.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9862",
    "data-name": "Path 9862",
    d: "M57.682,12.5a1.433,1.433,0,0,0,0,2.866H70.574a4.256,4.256,0,0,1,4.3,4.3V32.556a1.433,1.433,0,1,0,2.866,0V19.663A7.181,7.181,0,0,0,70.574,12.5Z",
    transform: "translate(-26.167 -12.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9863",
    "data-name": "Path 9863",
    d: "M40.888,20.832a1.432,1.432,0,0,0-1.432,1.434v7.258a11.487,11.487,0,0,0-9.932,9.932H22.266a1.432,1.432,0,1,0,0,2.863h7.258a11.487,11.487,0,0,0,9.932,9.932V59.51a1.432,1.432,0,1,0,2.863,0V52.252a11.487,11.487,0,0,0,9.932-9.932H59.51a1.432,1.432,0,1,0,0-2.863H52.252a11.487,11.487,0,0,0-9.932-9.932V22.266a1.435,1.435,0,0,0-1.432-1.434ZM38.022,35.159a2.865,2.865,0,1,1-2.863,2.863A2.887,2.887,0,0,1,38.022,35.159Z",
    transform: "translate(-15.103 -15.103)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProctoringIcon);
export default __webpack_public_path__ + "static/media/proctoring-icon.7e8eb84f6838c384acfb02f10a5de72a.svg";
export { ForwardRef as ReactComponent };